import { isMap } from "@thi.ng/checks/is-map";
export function into(dest, src) {
    if (isMap(dest)) {
        for (let x of src) {
            dest.set(x[0], x[1]);
        }
    }
    else {
        for (let x of src) {
            dest.add(x);
        }
    }
    return dest;
}
